import React from 'react';

import SearchBox from '../SearchBox/SearchBox';

interface RoleSearchBoxRole {
    id: number;
    title: string;
}
interface RoleSearchBoxProps<T extends RoleSearchBoxRole> {
    allRoles: T[];
    onSelectedRole: (newRole: T) => void;
    onTextChanged?: (newText: string) => void;
    placeholder?: string;
}

/**
 * Modern RoleSearchBox component without CSS wrapper.
 * @param {RoleSearchBoxProps} props - The props for the RoleSearchBox component.
 * @returns {JSX.Element} - The rendered RoleSearchBox component.
 */
function RoleSearchBox<T extends RoleSearchBoxRole>(props: RoleSearchBoxProps<T>) {
    return (
        <SearchBox
            elements={props.allRoles}
            onTextChange={props.onTextChanged}
            placeholder={props.placeholder || 'Nach Rollen suchen...'}
            onSelect={(selectedElement): void => {
                props.onSelectedRole(selectedElement as T);
            }}
        />
    );
}

export default RoleSearchBox;
